import React from "react";

const YellowGradient = ({ className }) => {
  return (
    <svg
      width="328"
      height="642"
      viewBox="0 0 328 642"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className || ""}
    >
      <g filter="url(#filter0_f_6386_26244)">
        <rect
          width="456"
          height="456"
          rx="228"
          transform="matrix(1 0 0 -1 200 656)"
          fill="#EFBF04"
          fillOpacity="0.32"
        />
      </g>
      <defs>
        <filter
          id="filter0_f_6386_26244"
          x="0"
          y="0"
          width="856"
          height="856"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="100"
            result="effect1_foregroundBlur_6386_26244"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default YellowGradient;
